import { useCallback, useState } from "react";

import { VISIT_FEE_STRIPE_PRICE_ID } from "@utils/constantsEnv";

import { coupons } from "../../api";

export type PromoDetails = {
  id: string;
  customer: string;
  code: string;
  coupon: {
    amount_off?: number;
    percent_off?: number;
  };
};

const useValidatePromo = () => {
  const [isValidPromo, setIsValid] = useState<boolean | null>(null);
  const [promoDetails, setPromoDetails] = useState<PromoDetails | null>(null);

  const validatePromo = useCallback(async (code: string, userCodes: string[] = []) => {
    try {
      const { data } = await coupons.couponGet(`/promo_code?code=${code}&active=true`);
      const promoCode = data[0];
      // If the promo code is for a customer, but user does not have promocodes
      // it means it doesn't belong to this user, so is **exclusive**
      const promoCodeIsExclusive = promoCode?.customer && userCodes.length === 0;
      const promoCodeIsValid =
        promoCode &&
        promoCode.coupon.metadata.price === VISIT_FEE_STRIPE_PRICE_ID &&
        promoCode.coupon.valid &&
        !promoCodeIsExclusive;

      setIsValid(promoCodeIsValid);
      setPromoDetails(promoCode);
    } catch (err) {
      setIsValid(false);
    }
  }, []);

  return { validatePromo, isValidPromo, promoDetails };
};

export default useValidatePromo;
